import { pinia } from '@tools/pinia';
import { createApp } from 'vue';
import Paginator from '@pages/seller-page-brand/paginator/Paginator.vue';

export const initPaginator = () => {
  if (!document.querySelector('#pagination')) {
    return;
  }

  createApp(Paginator)
    .use(pinia)
    .mount('#pagination');
};
